import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  Button,
  MenuItem,
  Typography,
  Box,
  Grid,
} from "@mui/material";
import { getStateData } from "./citydata";
import { CircularProgress } from "@mui/material";




const roles = ["Manufacturer", "Real Estate Builder", "Interior Designer"];
const registerurl =
  "https://jrdz3puxnh.execute-api.ap-south-1.amazonaws.com/production/registerdesign247user";

const RegisterPopup = ({ open, handleClose }) => {
  const [registrationData, setRegistrationData] = useState({
    name: "",
    email: "",
    phone: "",
    companyname: "",
    password: "",
    state: "",
    city: "",
    pincode: "",
    role: "",
  });
const [loading, setLoading] = useState(false);
const [redirecting, setRedirecting] = useState(false);
  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [cities, setCities] = useState([]);

  const states = Object.keys(getStateData());

  useEffect(() => {
    if (selectedState) {
      setCities(getStateData()[selectedState] || []);
    } else {
      setCities([]);
    }
  }, [selectedState]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setRegistrationData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "state") {
      setSelectedState(value);
    }

    if (name === "city") {
      setSelectedCity(value);
    }
  };

// check if all fields are filled
const isFormValid = Object.values(registrationData).every(
  (value) => value.trim() !== ""
);


 const handleSubmit = async () => {
  // check validation before sending
  const isFormValid = Object.values(registrationData).every(
    (value) => value.trim() !== ""
  );

  if (!isFormValid) {
    alert("Please fill in all fields before submitting.");
    return; // stop here if not filled
  }

  setLoading(true);
  try {
    const response = await fetch(registerurl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(registrationData),
    });

    const result = await response.json();
    console.log("Register Success:", result);

    alert("Registration successful!");
    setRedirecting(true);
    setLoading(false);

    setTimeout(() => {
      window.location.href = "https://design247.co.in";
    }, 2500);
  } catch (error) {
    console.error("Registration failed:", error);
    alert("Registration failed. Try again.");
    setLoading(false);
  }
};



  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogContent sx={{ p: 3 }}>
        <Box display="flex" flexDirection={{ xs: "column", md: "row" }}>
          {/* Left Image Section */}
          <Box
  sx={{
    width: { xs: "0%", md: "50%" },
    display: { xs: "none", md: "block" }, // Hide on xs
    pr: { md: 2 },
    maxHeight: "600px",
    overflowY: "auto",
    padding: "20px",
  }}
>

            <Grid container spacing={1}>
              {[
                "https://design247bucket.s3.ap-south-1.amazonaws.com/bathroom.jpg",
                "https://design247bucket.s3.ap-south-1.amazonaws.com/1bhk.jpeg",
                "https://design247bucket.s3.ap-south-1.amazonaws.com/kitchen.jpg",
                "https://design247bucket.s3.ap-south-1.amazonaws.com/lr2.jpg",
                "https://design247bucket.s3.ap-south-1.amazonaws.com/dinning.jpg",
                "https://design247bucket.s3.ap-south-1.amazonaws.com/bedroom.jpg",
              ].map((img, idx) => (
                <Grid item xs={6} key={idx}>
                  <img
                    src={img}
                    alt={`img${idx}`}
                    style={{
                      width: "250px",
                      height: "190px",
                      objectFit: "cover",
                        borderRadius: "8px",
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Right Form Section */}
          <Box
  sx={{
    width: { xs: "100%", md: "50%" },
    pl: { md: 2 },
    mt: { xs: 3, md: 0 },
  }}
>
            <Typography variant="h6" fontWeight="bold">
              Community for Top Designers & Brands
            </Typography>
            <Typography variant="body2" mb={2}>
              Connect, collaborate, and showcase your creativity to redefine
              home decor and interiors.
            </Typography>

            {[
              { name: "name", label: "Enter Name" },
              { name: "companyname", label: "Company Name" },
              { name: "email", label: "Email Address" },
              { name: "password", label: "Password", type: "password" },
              { name: "phone", label: "Mobile No" },
              { name: "pincode", label: "Pincode" },
            ].map((field) => (
              <TextField
                key={field.name}
                fullWidth
                margin="dense"
                name={field.name}
                label={field.label}
                type={field.type || "text"}
                value={registrationData[field.name]}
                onChange={handleChange}
                sx={{ "& .MuiInputBase-root": { height: 42 } }} // reduced height
              />
            ))}

            <TextField
              select
              fullWidth
              margin="dense"
              name="state"
              label="Select State"
              value={registrationData.state}
              onChange={handleChange}
              sx={{ "& .MuiInputBase-root": { height: 42 } }}
            >
              {states.map((state) => (
                <MenuItem key={state} value={state}>
                  {state}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              fullWidth
              margin="dense"
              name="city"
              label="Select City"
              value={registrationData.city}
              onChange={handleChange}
              sx={{ "& .MuiInputBase-root": { height: 42 } }}
            >
              {cities.map((city) => (
                <MenuItem key={city} value={city}>
                  {city}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              select
              fullWidth
              margin="dense"
              name="role"
              label="Select Role"
              value={registrationData.role}
              onChange={handleChange}
              sx={{ "& .MuiInputBase-root": { height: 42 } }}
            >
              {roles.map((role) => (
                <MenuItem key={role} value={role}>
                  {role}
                </MenuItem>
              ))}
            </TextField>

           <Button
  fullWidth
  variant="contained"
  disabled={loading || redirecting}
  sx={{ mt: 2, backgroundColor: "#1dbf73", color: "#fff" }}
  onClick={handleSubmit}
>
  {loading ? (
    <CircularProgress size={24} sx={{ color: "#fff" }} />
  ) : redirecting ? (
    "Redirecting..."
  ) : (
    "Sign up"
  )}
</Button>

          
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default RegisterPopup;
